import React from "react";
// import Navbar from "../components/Navbar";
import Contact from "../Component/Contact";
import ContactForm from "../Component/ContactForm";



const Contactus = () => {
    return (
     <>
  {/* <Navbar/> */}
  <Contact/>
  <ContactForm/>
 
  
  
    
  
      
  </>
      
    );
  };
  
  export default Contactus;
  